import { BlokProps } from '@/lib/types'
import { SnippetStoryblok } from '@/lib/types/component-types-sb'
import { StoryblokServerComponent } from '@storyblok/react/rsc'

export function Snippet({ blok }: BlokProps<SnippetStoryblok>) {
  return blok.body?.map((item) => {
    return (
      <StoryblokServerComponent
        blok={item}
        key={blok._uid}
      />
    )
  })
}
